import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer } from '../data/content';
const HIDE_ON = ['inicio', 'oferta', 'cierre'];
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const overlapping = HIDE_ON.some(id => {
        const el = document.getElementById(id);
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      setVisible(!overlapping);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-202" data-mp="gza4kiz8chyo">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/30 bg-cream/95 px-4 py-3 backdrop-blur" data-id="element-203" data-mp="75vq57mnwf74">
          <div className="mx-auto flex max-w-content items-center justify-between gap-3" data-id="element-204" data-mp="c4p8bdcw8udm">
            <div className="flex-none" data-id="element-205" data-mp="pvlwmrzsepev">
              <p className="font-display text-xl font-bold leading-none text-brown" style={{
            fontSize: "36px"
          }} data-id="element-206" data-mp="puk93o1l4ag9">{offer.price}</p>
              <p className="mt-0.5 font-sans text-[0.62rem] font-semibold uppercase tracking-[0.12em] text-ink-soft" data-id="element-207" data-mp="zujfpfeg1qqh">
                <span className="hidden sm:inline" data-id="element-208" data-mp="uuyjhcqnrwhg">Desafío + 5 bonos · </span>
                {offer.note}
              </p>
            </div>
            <CtaButton href={checkoutUrl} size="md" className="!px-5 sm:!px-8" data-id="element-209" data-mp="31mg1dhubsgyz">
              QUIERO COMENZAR
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}